import React from 'react'

import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { Show, TagField, TextField, BooleanField, RefreshButton, EditButton } from "@refinedev/antd";
import { Typography } from "antd";
import { FieldDB, TableDB } from 'interfaces/schemaDB';
import { useSchemaDB } from 'hooks/useSchemaDB';

const { Title } = Typography;

interface Cw8ShowProps{
    resourceName: string
} 

const Cw8Show = ({resourceName} : Cw8ShowProps ) => {

    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;
    const record = data?.data;

    const {schemaDBState,  getTable, getViewField } = useSchemaDB({nameTable:resourceName})
    const table : TableDB[] | null = getTable(resourceName)
    const fieldList: FieldDB[] =  getViewField(table?.length==1?table[0]:null)
        
    return (
        <Show isLoading={isLoading} headerButtons={<><EditButton /><RefreshButton /></>} breadcrumb={<span></span>}>
                    {
                        fieldList.map( (field, idx) =>(
                            <>
                                <Title level={5}>{field.label}</Title>
                                {field.type=="checkbox"?(
                                    <BooleanField value={record?record[field.name]:null} /> 
                                ):
                                <TextField value={record?record[field.name]:null} />
                                }
                            </>
                        ))
                    }            
            {/* <Title level={5}>Id</Title>
            <TextField value={record?.id} />
            <Title level={5}>Frt Name</Title>
            <TextField value={record?.frt_name} />
            <Title level={5}>Frt Active</Title>
            <BooleanField value={record?.frt_active} /> */}
        </Show>
    )
}

export default Cw8Show
